/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIFamily } from './APIFamily';
import {
    APIFamilyFromJSON,
    APIFamilyFromJSONTyped,
    APIFamilyToJSON,
} from './APIFamily';

/**
 * 
 * @export
 * @interface APIPaginatedFamilyList
 */
export interface APIPaginatedFamilyList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedFamilyList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedFamilyList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedFamilyList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIFamily>}
     * @memberof APIPaginatedFamilyList
     */
    results: Array<APIFamily>;
}

/**
 * Check if a given object implements the APIPaginatedFamilyList interface.
 */
export function instanceOfAPIPaginatedFamilyList(value: object): value is APIPaginatedFamilyList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedFamilyListFromJSON(json: any): APIPaginatedFamilyList {
    return APIPaginatedFamilyListFromJSONTyped(json, false);
}

export function APIPaginatedFamilyListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedFamilyList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIFamilyFromJSON)),
    };
}

export function APIPaginatedFamilyListToJSON(value?: APIPaginatedFamilyList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIFamilyToJSON)),
    };
}

